import { useForm } from "react-hook-form";
import { emailValidation, required } from "models/validations";
import { Auth } from "aws-amplify";
import { useAuthenticator } from "auth/useAuthenticator";
import { useAppDispatch } from "store/hooks";
import { showSpinner, hideSpinner } from "store/reducers/spinnerReducer";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
import { useEffect, useState } from "react";

export const useLogin = () => {
  const { register, handleSubmit, watch, formState } = useForm();
  const { errors } = formState;
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [error, setError] = useState("");

  const usernameRegisterProps = register("username", emailValidation);
  const passwordRegisterProps = register("password", { required });

  const { signIn } = useAuthenticator();
  const dispatch = useAppDispatch();

  const onSubmit = handleSubmit(async (newData) => {
    if (!newData) return;

    const { username, password } = newData;
    dispatch(showSpinner());
    setError("");
    try {
      const user = await Auth.signIn(username, password);
      if (user) {
        signIn(user);
      }
    } catch (error) {
      const errorParts = String(error)?.split(":");
      const errorMessage =
        errorParts?.length === 2 ? errorParts.slice(-1)[0]?.trim() : null;
      const message =
        error?.response?.data?.message ??
        error?.response?.data?.error ??
        errorMessage ??
        "Something went wrong";
      setError(message ?? getApiErrorMessage(error));
    } finally {
      dispatch(hideSpinner());
    }
  });

  const username = watch("username");
  const password = watch("password");

  useEffect(() => {
    setError("");
  }, [username, password]);

  return {
    errors,
    onSubmit,
    usernameRegisterProps,
    passwordRegisterProps,
    isPasswordVisible,
    setIsPasswordVisible,
    error,
  };
};
